(function () {
  'use strict';

  /* ── Sticky Mobile ATC ───────────────────────────────────────── */
  function initStickyATC() {
    var bar = document.querySelector('.mk-sticky-atc');
    if (!bar) return;

    var sectionId = bar.getAttribute('data-section');
    var formBtn = document.getElementById('product-form-' + sectionId)
      ? document.getElementById('product-form-' + sectionId).querySelector('[name="add"]')
      : null;
    if (!formBtn) return;

    function syncPrice() {
      var saleEl = document.querySelector('.product__info-wrapper .price--large .price-item--sale');
      var regEl  = document.querySelector('.product__info-wrapper .price--large .price-item--regular');
      var valEl  = bar.querySelector('.mk-satc-price-val');
      if (!valEl) return;
      var src = saleEl || regEl;
      if (src) valEl.textContent = src.textContent.trim();
    }

    var trigger = formBtn.closest('.product-form__buttons') || formBtn;
    var io = new IntersectionObserver(function (entries) {
      var vis = entries[0].isIntersecting;
      bar.classList.toggle('mk-sticky-atc--visible', !vis);
      bar.setAttribute('aria-hidden', vis ? 'true' : 'false');
      if (!vis) syncPrice();
    }, { threshold: 0.2 });
    io.observe(trigger);

    bar.addEventListener('click', function (e) {
      if (!e.target.closest('.mk-sticky-atc__btn')) return;
      var mainBtn = document.querySelector('#product-form-' + sectionId + ' [name="add"]');
      if (mainBtn) mainBtn.click();
    });

    document.addEventListener('variant:change', syncPrice);
  }

  /* ── Scroll Reveal on Product Info Blocks ────────────────────── */
  function initScrollReveal() {
    var container = document.querySelector('[id^="ProductInfo-"]');
    if (!container) return;

    var children = Array.prototype.slice.call(container.children);
    var idx = 0;

    children.forEach(function (el) {
      if (el.classList.contains('scroll-trigger')) return;
      el.style.transitionDelay = (idx * 55) + 'ms';
      el.classList.add('mk-reveal');
      idx++;
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mk-reveal--in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0 });

    children.forEach(function (el) {
      if (el.classList.contains('mk-reveal')) io.observe(el);
    });
  }

  /* ── Gallery Arrow Navigation (Desktop thumbnail layout) ─────── */
  /*
   * Sense theme's "thumbnail" gallery hides all non-active slides with
   * display:none, so the SliderComponent cannot calculate sliderItemOffset
   * and the default button clicks scroll to NaN (no-op).
   * We intercept the prev/next buttons and navigate via thumbnail clicks,
   * which triggers the media-gallery custom element's setActiveMedia().
   */
  function initGalleryArrows() {
    var viewer = document.querySelector('[id^="GalleryViewer-"]');
    if (!viewer) return;

    var gallery = viewer.closest('media-gallery');
    var prevBtn = viewer.querySelector('.slider-button--prev');
    var nextBtn = viewer.querySelector('.slider-button--next');
    if (!prevBtn || !nextBtn) return;

    function getThumbs() {
      var strip = gallery && gallery.querySelector('[id^="GalleryThumbnails-"]');
      return strip ? Array.from(strip.querySelectorAll('[data-target]')) : [];
    }

    function getActiveIdx(thumbs) {
      var active = viewer.querySelector('[data-media-id].is-active');
      if (!active) active = viewer.querySelector('[data-media-id]');
      if (!active) return 0;
      var id = active.dataset.mediaId;
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].dataset.target === id) return i;
      }
      return 0;
    }

    function navigate(dir) {
      var thumbs = getThumbs();
      if (!thumbs.length) return;
      var idx = getActiveIdx(thumbs);
      var newIdx = dir === 'next'
        ? (idx + 1) % thumbs.length
        : (idx - 1 + thumbs.length) % thumbs.length;
      var btn = thumbs[newIdx] && thumbs[newIdx].querySelector('button');
      if (btn) btn.click();
    }

    prevBtn.addEventListener('click', function () { navigate('prev'); });
    nextBtn.addEventListener('click', function () { navigate('next'); });
  }

  /* ── Gallery Swipe (Mobile) ──────────────────────────────────── */
  function initGallerySwipe() {
    var slider = document.querySelector('.product__media-list');
    if (!slider) return;

    var startX = 0;
    var startY = 0;

    slider.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });

    slider.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < 44 || Math.abs(dy) > Math.abs(dx) * 0.7) return;
      var comp = slider.closest('slider-component');
      if (!comp) return;
      var name = dx < 0 ? 'next' : 'previous';
      var btn = comp.querySelector('button[name="' + name + '"]');
      if (btn && !btn.disabled) btn.click();
    }, { passive: true });
  }

  /* ── Gallery counter: keep "current / total" honest ──
     Sense's slider-component computes pages from slide widths and shows
     "NaN / Infinity" when slides have no measurable width (stacked layout).
     Derive the numbers from the media list instead. */
  function initGalleryCounter() {
    var viewer = document.querySelector('[id^="GalleryViewer-"]');
    if (!viewer) return;
    var current = viewer.parentElement.querySelector('.slider-counter--current');
    var total = viewer.parentElement.querySelector('.slider-counter--total');
    var slides = viewer.querySelectorAll('[data-media-id]');
    if (!slides.length) return;

    function update() {
      var active = viewer.querySelector('[data-media-id].is-active') || slides[0];
      var idx = Array.prototype.indexOf.call(slides, active);
      if (current) current.textContent = idx + 1;
      if (total) total.textContent = slides.length;
    }
    update();
    var mo = new MutationObserver(update);
    slides.forEach(function (s) { mo.observe(s, { attributes: true, attributeFilter: ['class'] }); });
    // also guard against the theme rewriting the counter to NaN on resize/scroll
    if (current) {
      var cmo = new MutationObserver(function () {
        if (/NaN|Infinity/.test(current.textContent + (total ? total.textContent : ''))) update();
      });
      cmo.observe(current.parentElement, { childList: true, subtree: true, characterData: true });
    }
  }

  /* ── Rating badge → smooth scroll to reviews ── */
  function initRatingScroll() {
    document.querySelectorAll('.mk-rating-badge').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById('mk-reviews')
                  || document.getElementById('shopify-section-reviews')
                  || document.querySelector('.mikaya-reviews')
                  || document.querySelector('[id^="MkReviews-"]');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ── Product Info Tabs (Aesop-style sliding indicator) ── */
  function initProductTabs() {
    var groups = document.querySelectorAll('.mk-ptabs');
    groups.forEach(function (group) {
      var btns      = group.querySelectorAll('.mk-ptabs__btn');
      var indicator = group.querySelector('.mk-ptabs__indicator');
      var panels    = group.querySelectorAll('.mk-ptabs__panel');

      function moveIndicator(btn) {
        if (!indicator) return;
        indicator.style.left  = btn.offsetLeft + 'px';
        indicator.style.width = btn.offsetWidth + 'px';
      }

      function activateTab(btn) {
        var panelId = btn.dataset.panel;
        btns.forEach(function (b) {
          b.classList.remove('mk-ptabs__btn--active');
          b.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) { p.classList.remove('mk-ptabs__panel--active'); });
        btn.classList.add('mk-ptabs__btn--active');
        btn.setAttribute('aria-selected', 'true');
        var panel = document.getElementById(panelId);
        if (panel) panel.classList.add('mk-ptabs__panel--active');
        moveIndicator(btn);
      }

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () { activateTab(btn); });
      });

      var activeBtn = group.querySelector('.mk-ptabs__btn--active');
      if (activeBtn) requestAnimationFrame(function () { moveIndicator(activeBtn); });
    });
  }

  /* ── Cart Drawer ─────────────────────────────────────────────── */

  function mkOpenDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
  }

  function mkCloseDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.classList.remove('active', 'animate');
    document.body.classList.remove('overflow-hidden');
  }

  function mkAnimateShipBar() {
    var fill = document.querySelector('.mkcd__ship-fill');
    if (!fill) return;
    var pct = parseFloat(fill.dataset.pct || 0);
    fill.style.transition = 'none';
    fill.style.width = '0%';
    fill.getBoundingClientRect();
    fill.style.transition = '';
    fill.style.width = pct + '%';
  }

  // Open on cart icon click — capture phase + stopImmediatePropagation blocks
  // cart-drawer.js's own listener so we own the full open/close lifecycle.
  document.addEventListener('click', function(e) {
    var cartLink = e.target.closest('#cart-icon-bubble');
    if (!cartLink) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    mkOpenDrawer();
  }, true);

  // Close on button / overlay clicks
  document.addEventListener('click', function(e) {
    if (e.target.closest('.mkcd__close, .mkcd__empty-cta, #CartDrawer-Overlay')) {
      mkCloseDrawer();
    }
  });

  // Close on Escape
  document.addEventListener('keyup', function(e) {
    if (e.code === 'Escape') mkCloseDrawer();
  });

  // Swipe down to close (mobile)
  var mkSwipeY = 0;
  var mkSwiping = false;
  document.addEventListener('touchstart', function(e) {
    if (window.innerWidth > 749) return;
    if (!document.querySelector('cart-drawer.active')) return;
    if (!e.target.closest('.mkcd__handle, .mkcd__header')) return;
    mkSwipeY = e.touches[0].clientY;
    mkSwiping = true;
  }, { passive: true });
  document.addEventListener('touchend', function(e) {
    if (!mkSwiping) return;
    mkSwiping = false;
    if (e.changedTouches[0].clientY - mkSwipeY > 80) mkCloseDrawer();
  }, { passive: true });

  // Animate ship bar when drawer opens
  (function() {
    var el = document.querySelector('cart-drawer');
    if (!el) return;
    new MutationObserver(function(muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].attributeName === 'class' && el.classList.contains('active')) {
          setTimeout(mkAnimateShipBar, 60);
          break;
        }
      }
    }).observe(el, { attributes: true });
  }());

  // First-order offer button
  document.addEventListener('click', function(e) {
    if (!e.target.closest('#mkcd-first-order-btn')) return;
    var input = document.getElementById('mkcd-discount-code');
    if (input) { input.value = 'MIKAYA10'; input.focus(); input.select(); }
    var strip = document.getElementById('mkcd-offer-strip');
    if (strip) strip.classList.add('is-used');
  });

  // Discount form → checkout redirect
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('#mkcd-discount-form');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('.mkcd__coupon-input');
    var code = input ? input.value.trim() : '';
    if (!code) return;
    var fb = document.getElementById('mkcd-coupon-feedback');
    if (fb) { fb.textContent = 'Redirecting...'; fb.className = 'mkcd__coupon-feedback'; }
    window.location.href = '/checkout?discount=' + encodeURIComponent(code);
  });

  // Checkout button loading state
  document.addEventListener('submit', function(e) {
    if (!e.target.closest('#CartDrawer-Form')) return;
    var btn = document.getElementById('CartDrawer-Checkout');
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
  });

  // FBT / upsell add-to-cart
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.mk-fbt-add-btn');
    if (!btn || !btn.dataset.variantId || btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(btn.dataset.variantId, 10), quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      setTimeout(function() { if (window.mkRefreshCart) window.mkRefreshCart(); mkOpenDrawer(); }, 250);
    })
    .catch(function() { btn.disabled = false; btn.classList.remove('is-loading'); });
  });

  // Shared cart refresh helper
  window.mkRefreshCart = function() {
    var inDrawer = !!document.querySelector('cart-drawer');
    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    var sections = ['cart-icon-bubble'];
    if (inDrawer) sections.push('cart-drawer');
    if (itemsEl && itemsEl.dataset.id) sections.push(itemsEl.dataset.id);
    if (footerEl && footerEl.dataset.id && footerEl.dataset.id !== (itemsEl && itemsEl.dataset.id))
      sections.push(footerEl.dataset.id);
    return fetch('/?sections=' + sections.join(','))
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var p = new DOMParser();
        if (data['cart-drawer']) {
          var panel = document.querySelector('.drawer__inner');
          if (panel) {
            var newPanel = p.parseFromString(data['cart-drawer'], 'text/html').querySelector('.drawer__inner');
            if (newPanel) { panel.innerHTML = newPanel.innerHTML; mkAnimateShipBar(); }
          }
        }
        if (itemsEl && itemsEl.dataset.id && data[itemsEl.dataset.id]) {
          var jsC = itemsEl.querySelector('.js-contents');
          if (jsC) {
            var newC = p.parseFromString(data[itemsEl.dataset.id], 'text/html').querySelector('.js-contents');
            if (newC) jsC.innerHTML = newC.innerHTML;
          }
        }
        if (footerEl && footerEl.dataset.id && data[footerEl.dataset.id]) {
          var jsC2 = footerEl.querySelector('.js-contents');
          if (jsC2) {
            var newC2 = p.parseFromString(data[footerEl.dataset.id], 'text/html').querySelector('.js-contents');
            if (newC2) jsC2.innerHTML = newC2.innerHTML;
          }
        }
        if (data['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            var inner = p.parseFromString(data['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
            if (inner) bubble.innerHTML = inner.innerHTML;
          }
        }
      });
  };

  /* ── Generic PDP modals (Ask a question, Delivery & Return) ── */
  function initModals() {
    function open(id) {
      var m = document.getElementById(id);
      if (!m) return;
      m.hidden = false;
      document.body.classList.add('overflow-hidden');
      var f = m.querySelector('input, textarea, button');
      if (f) try { f.focus(); } catch (e) {}
    }
    function close(m) { if (m) { m.hidden = true; document.body.classList.remove('overflow-hidden'); } }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-mk-modal]');
      if (t) { e.preventDefault(); open(t.getAttribute('data-mk-modal')); return; }
      if (e.target.closest('[data-mk-modal-close]')) { close(e.target.closest('.mk-modal')); }
    });
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('.mk-modal:not([hidden])').forEach(close);
    });
    // If the contact form posted successfully, Shopify reloads with ?contact_posted=true — reopen the modal.
    if (/contact_posted=true/.test(location.search)) open('mk-ask');
  }

  /* ── Share (native share sheet → copy-link fallback) ── */
  function initShare() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mk-share]');
      if (!b) return;
      e.preventDefault();
      var url = b.getAttribute('data-share-url') || location.href;
      var title = b.getAttribute('data-share-title') || document.title;
      if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); }
      else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          var old = b.getAttribute('data-label') || b.textContent;
          b.classList.add('is-copied');
          setTimeout(function () { b.classList.remove('is-copied'); }, 1600);
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initStickyATC();
    initGalleryArrows();
    initGallerySwipe();
    initGalleryCounter();
    initProductTabs();
    initRatingScroll();
    initModals();
    initShare();
  });
})();
